import { useTheme } from "@emotion/react";
import tinycolor from "tinycolor2";

type Props = {
  title: string;
  href: string;
  icon: React.ReactNode;
  time: string;
  appLabel: string;
  docTypeLabel: string;
  onClick?: () => void;
};

export const HistoryBrowserEntry: React.FC<Props> = ({
  title,
  href,
  icon,
  time,
  appLabel,
  docTypeLabel,
  onClick,
}) => {
  const theme = useTheme();

  return (
    <div
      css={{
        position: "relative",
        display: "flex",
        alignItems: "flex-start",
        gap: "0.625rem",
        cursor: onClick ? "pointer" : "auto",
        minHeight: "52px",
        padding: "0.375rem 0",
        "&:last-child hr": {
          display: "none",
        },
        "&:hover .history-entry-title": onClick ? { textDecoration: "underline" } : undefined,
      }}
      onClick={onClick}
    >
      <hr
        css={{
          height: "calc(100% - 28px)",
          width: "1px",
          background: `${tinycolor(theme.colors.primary).setAlpha(0.3)}`,
          position: "absolute",
          left: "15px",
          top: "40px",
          border: "none",
        }}
      />

      <div
        css={{
          width: "30px",
          height: "30px",
          borderRadius: "50%",
          background: theme.colors.primaryLight,
          padding: "7px",
          fontSize: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: theme.colors.primary,
          flexShrink: 0,
        }}
      >
        {icon}
      </div>

      <div css={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: "0.125rem" }}>
        <span
          className="history-entry-title"
          css={{
            color: theme.colors.primary,
            fontSize: "14px",
            fontWeight: 500,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {title}
        </span>

        <span
          css={{
            color: theme.colors.success,
            fontSize: "12px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            opacity: 0.85,
          }}
        >
          {href}
        </span>

        <span css={{ fontSize: "11px", opacity: 0.55 }}>
          {appLabel}
          {docTypeLabel ? ` · ${docTypeLabel}` : ""}
        </span>
      </div>

      <span css={{ fontSize: "12px", opacity: 0.6, textWrap: "nowrap", flexShrink: 0, paddingTop: "0.125rem" }}>
        {time}
      </span>
    </div>
  );
};
